// @ts-nocheck
import { Component, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { ASSETS } from '../../../../assets/assets';

@Component({
  selector: 'lbca-error-modal-broken',
  templateUrl: './error-modal.html',
  styleUrls: ['./error-modal.scss', './error-modal-draft.scss'],
})
export class ErrorModalBrokenClass implements OnInit, OnDestroy {
  readonly assets = inject(ASSETS);
  public SystemFeedbacks: any = {};
  private close;

  @Input() set setCallBackClose(func) {
    this.close = func;
  }

  ngOnInit(): void {
    this.SystemFeedbacks = this.assets.labels.feedbacks.system;
    document.getElementById('main-scroll')?.classList.add('blur');
  }
  ngOnDestroy(): void {
    document.getElementById('main-scroll')?.classList.remove('blur');
  }

  public closeModal() {
    this.close();
  }
}
